import React, { useMemo, useState, useEffect } from "react"
import { Box, Button, CircularProgress, Typography } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { getCrewDealMemo } from "../../actions/billing-crew-client"
import { isEmpty } from "lodash"
import billingTheme from "../../themes/billing"
import { MuiThemeProvider } from "@material-ui/core/styles"
import moment from "moment"
import CrewmamaAppBar from "../../components/CrewmamaAppBar/index"
import BillingPageLayout from "../../components/Billing/Common/BillingPageLayout/index"
import CrewBillingCard from "../../components/Billing/Crew/CrewBillingCard/index"
import CrewBillingRightActions from "../../components/Billing/Crew/CrewBillingRightActions/index"

const CrewBillingContent = props => {
  const dispatch = useDispatch()

  let shortCode = props.match.params.short_code

  // the local source of truth for crew deal memo & all child components
  const [crewDealMemo, setCrewDealMemo] = useState({})
  const [error, setError] = useState("")

  const confirmed =
    crewDealMemo &&
    crewDealMemo.user &&
    Boolean(crewDealMemo.user.bill_accepted)

  // Make call to populate the state val being used in the tables, etc.
  useEffect(() => {
    dispatch(getCrewDealMemo(shortCode))
      .then(res => {
        setCrewDealMemo(res)
        return res
      })
      .catch(err => {
        setError("No data to display.")
        console.log(err)
      })
  }, [])

  const wrapDate = crewDealMemo && crewDealMemo.end_date
  const hasWrapped = moment().isAfter(wrapDate, "day")

  // isolated crew member's user object, which includes expenses, etc.
  const crewMember = useMemo(
    () => {
      if (crewDealMemo && crewDealMemo.user) {
        return { ...crewDealMemo.user, shoot_id: crewDealMemo.shoot_id }
      }
    },
    [crewDealMemo]
  )

  if ((isEmpty(crewDealMemo) || !crewMember) && !error) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "calc(100vh - 64px)",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </div>
    )
  } else if (error) {
    return (
      <Typography variant="h4" style={{ marginTop: "20px" }}>
        {error}
      </Typography>
    )
  } else if (
    crewMember.user_status === "rejected" ||
    crewMember.user_status === "sent"
  ) {
    return (
      <Box
        mt={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h2" style={{ marginBottom: "25px" }}>
          {crewMember.user_status === "rejected" &&
            "You have rejected this shoot. Please return to your Deal Memo page to see further information."}
          {crewMember.user_status === "sent" &&
            "You must accept the deal memo prior to submitting your crew bill & any additional incurred expenses."}
        </Typography>
        <Button
          variant="outlined"
          onClick={() => props.history.push(`/deal-memo/${shortCode}`)}
        >
          Back to Deal Memo
        </Button>
      </Box>
    )
  }
  return (
    <BillingPageLayout
      leftHeader={`Submit Crew Bill for ${
        crewDealMemo && crewDealMemo.shoot_name
          ? crewDealMemo.shoot_name
          : crewMember.first_name + " " + crewMember.last_name
      }`}
      leftContent={
        <CrewBillingCard
          crewDealMemo={crewDealMemo}
          setCrewDealMemo={setCrewDealMemo}
          confirmed={confirmed}
        />
      }
      rightHeader={!confirmed ? "Actions" : "Status"}
      rightSubtitle={
        !confirmed &&
        `${
          hasWrapped ? "Nice! This shoot has wrapped. " : ""
        }Please submit any additional expenses that you incurred for this shoot.`
      }
      rightContent={
        <CrewBillingRightActions
          crewDealMemo={crewDealMemo}
          setCrewDealMemo={setCrewDealMemo}
        />
      }
    />
  )
}

export const CrewBillingPage = props => {
  return (
    <MuiThemeProvider theme={billingTheme}>
      <CrewmamaAppBar />
      <CrewBillingContent {...props} />
    </MuiThemeProvider>
  )
}

export default CrewBillingPage
